(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chron-faq"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-chron-faq-btn]');
    if (!btn) return;
    var root = btn.closest('[data-chron-faq]');
    if (!root) return;
    var dd = btn.parentElement && btn.parentElement.nextElementSibling;
    if (!dd) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (open) {
      dd.setAttribute('hidden', '');
    } else {
      dd.removeAttribute('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chron-hero"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest(
      '[data-chron-carousel-prev], [data-chron-carousel-next], [data-chron-carousel-dot]'
    );
    if (!btn) return;
    var root = btn.closest('[data-chron-carousel]');
    if (!root) return;
    var slides = root.querySelectorAll('[data-chron-carousel-slide]');
    var dots = root.querySelectorAll('[data-chron-carousel-dot]');
    if (!slides.length) return;
    var current = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-on')) current = i;
    }
    var next = current;
    if (btn.hasAttribute('data-chron-carousel-prev')) {
      next = (current - 1 + slides.length) % slides.length;
    } else if (btn.hasAttribute('data-chron-carousel-next')) {
      next = (current + 1) % slides.length;
    } else if (btn.hasAttribute('data-chron-carousel-dot')) {
      next = parseInt(btn.getAttribute('data-index'), 10) || 0;
    }
    for (var j = 0; j < slides.length; j++) {
      slides[j].classList.toggle('is-on', j === next);
      if (dots[j]) dots[j].classList.toggle('is-on', j === next);
    }
  });

  (function () {
    var roots = document.querySelectorAll('[data-chron-carousel]');
    for (var r = 0; r < roots.length; r++) {
      (function (root) {
        var slides = root.querySelectorAll('[data-chron-carousel-slide]');
        var dots = root.querySelectorAll('[data-chron-carousel-dot]');
        if (slides.length < 2) return;
        setInterval(function () {
          var current = 0;
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].classList.contains('is-on')) current = i;
          }
          var next = (current + 1) % slides.length;
          for (var j = 0; j < slides.length; j++) {
            slides[j].classList.toggle('is-on', j === next);
            if (dots[j]) dots[j].classList.toggle('is-on', j === next);
          }
        }, 4500);
      })(roots[r]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chron-najczesciej"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-chron-naj-prev], [data-chron-naj-next]');
    if (!btn) return;
    var root = btn.closest('[data-chron-najczesciej]');
    if (!root) return;
    var viewport = root.querySelector('[data-chron-naj-viewport]');
    if (!viewport) return;
    var card = viewport.querySelector('.chron-najczesciej__card');
    var step = card ? card.getBoundingClientRect().width + 16 : viewport.clientWidth * 0.8;
    var dir = btn.hasAttribute('data-chron-naj-next') ? 1 : -1;
    viewport.scrollBy({ left: dir * step * 4, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chron-wybor"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-chron-variant]')) return;
    var root = input.closest('[data-chron-wybor]');
    if (!root) return;

    var label = input.closest('.chron-variant');
    var labels = root.querySelectorAll('.chron-variant');
    for (var i = 0; i < labels.length; i++) {
      labels[i].classList.remove('is-on');
    }
    if (label) label.classList.add('is-on');

    var price = root.querySelector('[data-chron-price]');
    if (price && input.getAttribute('data-price')) {
      price.textContent = input.getAttribute('data-price');
    }
    var compareValue = input.getAttribute('data-compare-price') || '';
    var comparePrice = root.querySelector('[data-chron-compare-price]');
    if (comparePrice) {
      comparePrice.textContent = compareValue;
      comparePrice.hidden = !compareValue;
    }

    var galleries = root.querySelectorAll('[data-chron-wybor-gallery]');
    for (var g = 0; g < galleries.length; g++) {
      var match = galleries[g].getAttribute('data-variant-id') === input.value;
      galleries[g].classList.toggle('is-on', match);
      if (match) {
        galleries[g].removeAttribute('hidden');
      } else {
        galleries[g].setAttribute('hidden', '');
      }
    }

    var submit = root.querySelector('[data-chron-wybor-submit]');
    if (submit) submit.disabled = !!input.disabled;

    var sticky = document.querySelector('[data-chron-sticky]');
    if (!sticky) return;
    var hidden = sticky.querySelector('[data-chron-sticky-variant]');
    var stickyPrice = sticky.querySelector('[data-chron-sticky-price]');
    if (hidden && input.value) hidden.value = input.value;
    if (stickyPrice && input.getAttribute('data-price')) {
      stickyPrice.textContent = input.getAttribute('data-price');
    }
    var stickyComparePrice = sticky.querySelector('[data-chron-sticky-compare-price]');
    if (stickyComparePrice) {
      stickyComparePrice.textContent = compareValue;
      stickyComparePrice.hidden = !compareValue;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tex-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('[data-tex-variant-id], [name="id"]')) return;

    var sectionRoot = target.closest('[data-tex-sticky-atc]');
    if (!sectionRoot && target.form) {
      var formSection = target.form.closest('[data-section-id]');
      if (formSection) {
        sectionRoot = document.querySelector(
          '[data-tex-sticky-atc][data-section-id="' +
            formSection.getAttribute('data-section-id') +
            '"]'
        );
      }
    }
    if (!sectionRoot) {
      var sticky = document.querySelector('[data-tex-sticky-atc]');
      if (!sticky) return;
      sectionRoot = sticky;
    }

    var scopedId = sectionRoot.getAttribute('data-section-id');
    var stickyScoped = document.querySelector(
      '[data-tex-sticky-atc][data-section-id="' + scopedId + '"]'
    );
    if (!stickyScoped) return;

    var hidden = stickyScoped.querySelector('[data-tex-sticky-variant]');
    if (hidden && target.value) {
      hidden.value = target.value;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
